import { combineReducers } from 'redux-immutable';
import { createResponsiveStateReducer } from 'redux-responsive';

// global store
import feedback from '../../../store/feedback/slices';
import client from '../../../store/client/reducers';
import logo from '../../../store/logo/reducers';
import menu from '../../../store/menu/slice';
import enqueue from '../../../store/enqueue/reducers';
import headerWidget from '../../../store/headerWidget/reducers';
import wishlist from '../../../store/wishlist/slice';
import cashback from '../../../store/cashback/slice';

import view from './view';

const rootReducer = combineReducers({
  feedback,
  client,
  logo,
  menu,
  view,
  enqueue,
  headerWidget,
  wishlist,
  cashback,
  browser: createResponsiveStateReducer({
    small: 694,
    medium: 960,
    large: 1270,
    extraLarge: 1600,
  }),
});

export default rootReducer;
